export default class ResponsiveVideo {
	constructor(video) {
		this.video = video;
		this.width = this.video.getBoundingClientRect().width * window.devicePixelRatio; // Get width taking pixel density into account

		this.handlePoster();
		this.video.addEventListener('play-video', () => {
			this.playVideo();
		});

		this.video.addEventListener('pause-video', () => {
			this.pauseVideo();
		});
		this.pickSource();
	}

	handlePoster() {
		this.videoParent = this.video.closest('.c-img-video');
		if (!this.videoParent) {
			return;
		}

		const poster = this.videoParent.querySelector('.c-img-video__poster');
		if (poster) {
			this.videoParent.addEventListener('click', () => {
				if (this.video.currentTime > 0 && !this.video.paused) {
					this.pauseVideo();
				} else {
					this.playVideo();
				}
			});
		}
	}

	pickSource() {
		this.matchedSource = null;
		this.prevDiff = 999999;

		// Loop over all video sources
		this.sourceCount = this.video.children.length;
		this.removedSources = 0;
		const removeSources = new Promise((resolve, reject) => {
			if (!this.video.children) {
				return;
			}

			Array.from(this.video.children).forEach((source) => {
				// Get source resolution (by provided by data attribute)
				let sourceWidth = source.dataset.sourcewidth;

				// Compare source resolution to video element width
				let currentDiff = sourceWidth - this.width;
				if (currentDiff <= 0) {
					currentDiff = currentDiff * -1;
				}
				if (currentDiff <= this.prevDiff) {
					this.matchedSource = source;
				}
				this.prevDiff = currentDiff;

				setTimeout(() => {
					source.remove();
					this.removedSources++;
					if (this.removedSources >= this.sourceCount) {
						resolve('Removed All Sources');
					}
				}, 0);
			});
		});

		removeSources.then(() => {
			if (!this.video) {
				return;
			}

			this.video.src = this.matchedSource.src;
		});
	}

	playVideo() {
		this.tryIntervalFunction();
		this.tryInterval = setInterval(() => {
			this.tryIntervalFunction();
		}, 1000);
	}

	tryIntervalFunction() {
		let startPlayPromise = this.video.play();
		if (startPlayPromise !== undefined) {
			startPlayPromise
				.then(() => {
					this.video.classList.add('has-played');
					if (this.videoParent) {
						this.videoParent.classList.add('c-img-video--playing');
						this.videoParent.classList.remove('c-img-video--error');
					}
					const playInterval = setInterval(() => {
						if (this.video.paused) {
							this.video.play();
							this.video.classList.remove('is-paused');
						} else {
							clearInterval(this.tryInterval);
							clearInterval(playInterval);
						}
					}, 10);
				})
				.catch((error) => {
					if (this.videoParent) {
						this.videoParent.classList.remove('c-img-video--playing');
						this.videoParent.classList.add('c-img-video--error');
					}
				});
		}
	}

	pauseVideo() {
		this.video.pause();
		this.video.classList.add('is-paused');
	}
}
